import type { TruckServiceItemView } from '@chukua/common';

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * When the truck's soonest time-based service falls due (`YYYY-MM-DD`): the date it was last done plus its interval in days. Items
 * measured in km or hours have no date, so they never set one, and an item never recorded as done has nothing to count from.
 * Null when none has: the booker then picks the due date themselves.
 */
export function earliestDayBasedDueDate(items: TruckServiceItemView[]): string | null {
  const dates = items.flatMap((item) => {
    if (item.intervalDays === null || item.lastDone?.doneOn == null) return [];
    return [new Date(Date.parse(`${item.lastDone.doneOn}T00:00:00Z`) + item.intervalDays * DAY_MS).toISOString().slice(0, 10)];
  });
  return dates.length === 0 ? null : dates.sort()[0];
}
